import configApi from "../configApi";

const sectionBaseURL = "/api/user/companies";

const apiCompanies = {
  index: async (page = 1) => {
    let url = `${sectionBaseURL}/?page=${page}`;
    return await configApi.get(url);
  },

  detail: async companyID => {
    let url = `${sectionBaseURL}/${companyID}`;
    return await configApi.get(url);
  }
};

export default apiCompanies;
